import Box from '@mui/material/Box';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  deleteVideoPage,
  getVideoPages,
  saveVideoPage,
} from 'services/videoPages.service';
import { snack } from 'utils/toast';
import VideoTable from '../components/VideoTable';
import { VideosContext } from '../index';

const DeletedVideos = ({}) => {
  const [data, setData] = useState();
  const { query, filterVideos } = useContext(VideosContext);

  useEffect(() => {
    getVideoPages({ page_deleted: 1 }).then(setData);
  }, []);

  const onAction = async (action, row) => {
    try {
      switch (action) {
        case 'restore': {
          await saveVideoPage({
            hash: row.hash,
            page_deleted: 0,
          });
          setData(data.filter((i) => i !== row));
          snack.success('Page restored.');
          break;
        }
        case 'delete': {
          await deleteVideoPage(row.hash);
          setData(data.filter((i) => i !== row));
          snack.success('Page deleted.');
          break;
        }
      }
    } catch (e) {
      snack.error(e.message);
    }
  };

  const filteredVideos = useMemo(() => {
    return filterVideos(data);
  }, [query, data]);

  return (
    <Box>
      <Helmet title="Deleted pages" />
      <VideoTable
        loading={!data}
        data={filteredVideos}
        onAction={onAction}
        noDataMessage="No Deleted Pages"
      />
    </Box>
  );
};

export default DeletedVideos;
